import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { FirewallPage } from '@/features/admin/firewall/firewall-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Pare-feu : règles du tenant (porting README #20). */
export const Route = createFileRoute('/$tenant/firewall/')({ component: FirewallRoute });

function FirewallRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="firewall" crumbs={[{ label: t('nav.items.firewall') }]}>
      <FirewallPage tenantId={tenant} />
    </ConsoleShell>
  );
}
